<template>
    <BreezeAuthenticatedLayout
        :title="title"
        :footerContainer="route().current() == 'dashboard.admin.lottery' ? true : false"
        :lang="isAdmin( $page.props.auth.user ) ? $page.props.profile_locale : null"
    >
        <div
            v-if="active && size <= 767"
            class="bg-sidebar bg-gray-900 bg-opacity-30 fixed inset-0 z-30 md:hidden block"
            @click="active = false;"
        ></div>
        <div class="">
            <div class="grid grid-cols-12 gap-3">
                <transition
                    enter-active-class="transition duration-300"
                    enter-from-class="transform -translate-x-full"
                    enter-to-class="transform  translate-x-0"
                    leave-active-class="transition duration-300"
                    leave-from-class="transform translate-x-0"
                    leave-to-class="transform -translate-x-full"

                    mode="out-in"

                    @after-leave="$emit('leave', null)"
                >
                    <div
                        class="shadow-md md:rounded-md rounded-r-md bg-white p-5 xl:col-span-2 lg:col-span-3 md:col-span-4 md:block md:relative fixed md:z-0 z-40 transition-all duration-300 transform left-0"
                        :ref="ev => { sidebar = ev }"
                        v-if="active && size <= 767 || size > 767"
                        :class="[
                            active && size <= 767 ? 'top-2 bottom-2 overflow-auto' : ''
                        ]"
                    >
                        <template v-for="m in menu" :key="m">
                            <InertiaLink
                                v-if="(m.admin == isAdmin($page.props.auth.user)) || !m.admin"
                                :key="m"
                                :href="route(m.route)"
                                class="flex p-2 rounded-md mb-1"
                                :class="route().current(m.current ? m.current : m.route) ? 'bg-gray-900 text-white' : 'hover:bg-gray-100 hover:text-black'"
                            >
                                <SvgIcon
                                    :name="m.icon"
                                    class="mr-2"
                                    :class="route().current(m.current ? m.current : m.route) ? '' : 'text-gray-600'"
                                    height= "22"
                                    width= "22"
                                />
                                <div>{{__(m.title, null, $page.props.profile_locale)}}</div>
                            </InertiaLink>
                        </template>
                        <div class="border-t pt-1">
                            <InertiaLink
                                :href="route('logout')"
                                class="flex p-2 rounded-md mb-1 group hover:bg-red-100 "
                            >
                                <SvgIcon
                                    name="logout"
                                    class="text-gray-600 mr-2"
                                    height= "22"
                                    width= "22"
                                />
                                <div>{{__('Log out', null, $page.props.profile_locale)}}</div>
                            </InertiaLink>
                        </div>
                    </div>
                </transition>
                <div class="bg-white shadow-md sm:rounded-md xl:col-span-10 lg:col-span-9 md:col-span-8 col-span-full p-5 md:pt-5 pt-0">
                    <div class="relative h-10 bg-gray-900 -mx-5 mb-2 rounded-t-md"
                        v-if="size <= 767"
                    >
                        <button
                            @click="active = !active"
                            class="absolute top-1 right-1 bg-gray-700 text-gray-200 rounded-md p-1 md:hidden block"
                        >
                            <svg class="h-6 w-6 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                <path v-if="!active" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                                <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <slot />
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated';
    import SvgIcon from 'UI/SvgIcon';
    import { ref } from '@vue/reactivity';
    import { usePage } from '@inertiajs/inertia-vue3';

    import {
        isAdmin
    } from 'helper';
import { Inertia } from '@inertiajs/inertia';

    export default {
        props: {
            title: String
        },
        setup(props) {
            const active = ref(false);
            const size = ref(window.screen.width);
            const sidebar = ref(null);
            const fullHeight = ref(false);

            $(window).on('resize', function() {
                size.value = window.screen.width;
            })

            const menu = [
                {
                    'route': 'dashboard.main',
                    'icon': 'chart-bar',
                    'title': 'Dashboard',
                },
                {
                    'route': isAdmin( usePage().props.value.auth.user ) ? 'admin.transactions' : 'dashboard.orders',
                    'current': isAdmin( usePage().props.value.auth.user ) && route().current() != 'admin.transactions' ? 'admin.transactions.*' : (!isAdmin( usePage().props.value.auth.user ) && route().current() != 'dashboard.orders' ? 'dashboard.orders.*' : null),
                    'icon':'currency-dolar',
                    'title': isAdmin( usePage().props.value.auth.user ) ?  'Transactions' : 'Orders',
                },
                {
                    'route': 'dashboard.profile',
                    'icon': 'server',
                    'title':'Settings',
                },
                // {
                //     'route':'dashboard.settings',
                //     'icon':'server',
                //     'title':'Settings',
                // },
                {
                    'route':'admin.users',
                    'current': route().current('admin.users') ? 'admin.users' : 'admin.users.*',
                    'icon':'users',
                    'title':'Users',
                    'admin':true
                },
                {
                    'route':'add.product',
                    'icon':'check',
                    'title':'Add product',
                    'admin':true
                },
                {
                    'route':'dashboard.engrave.index',
                    'current':'dashboard.engrave.*',
                    'icon':'pencil',
                    'title':'Engraver',
                    'admin':true
                },
                {
                    'route':'dashboard.admin.products',
                    'current':'dashboard.admin.*',
                    'icon':'paper-clip',
                    'title':'Admin panel',
                    'admin':true
                },
                {
                    'route':'dashboard.pages.index',
                    'current':'dashboard.pages.*',
                    'icon':'globe',
                    'title':'Pages',
                    'admin':true
                },
            ]

            Inertia.on('start', (event) => {
                active.value = false;
            })

            return {
                menu,
                active,
                size,
                sidebar,
                fullHeight
            }
        },
        components: {
            BreezeAuthenticatedLayout,
            SvgIcon
        },

        methods: { isAdmin }

    }
</script>
